import "../k";
import { addButton } from "../things/button";
import { goTransition } from "../util/goTransition";

scene("start", () => {
  add([sprite("logo"), pos(width() / 2, height() / 2 - 40), anchor("center")]);

  const startButton = addButton("button", [
    pos(width() / 2, height() * 0.75),
    {
      textContents: "Go!",
    },
  ]);

  startButton.onClick(() => {
    goTransition("levelSelect");
  });
});

